module.exports = __webpack_public_path__ + "static/6-5f12a9a2c63d1330de1706efc6e51c7d.jpg";